export * from './legalpages.module';
export * from './legalpages.routes';